import React from "react";
import { BoxIcon } from "lucide-react";
interface MedallionProps {
  icon: BoxIcon;
  className?: string;
}
export function Medallion({
  icon: Icon,
  className = ''
}: MedallionProps) {
  return <span className={`inline-flex h-14 w-14 items-center justify-center rounded-full border border-lime-ink/25 bg-lime-soft ${className}`} aria-hidden="true" data-id="element-103" data-mp="1zbqyo7zazzuw">
      <Icon className="h-6 w-6 text-lime-ink" strokeWidth={1.6} data-id="element-104" data-mp="249aehcbngkoy" />
    </span>;
}